export type testType = {
    test_id: number;
    start_date: string | null;
    end_date: string | null;
    active_versions: number[];
    allocation: number[];
};

// A/B test configuration list, test id 0 is the default test with version 1 always active (used as fallback).
// Each test has a start date (optinally end date), active versions and their allocation percentages.
export const abTests = [
  {
    test_id: 0,
    start_date: null,
    end_date: null,
    active_versions: [1],
    allocation: [1.0],
    description: 'Default test used for fallback with version 1 getting 100% of traffic and always active',
    hypothesis: 'No hypothesis, this is the default test',
  },
  {
    test_id: 1,
    start_date: '2025-07-20',
    end_date: null,
    active_versions: [1, 2, 3],
    allocation: [0.3334, 0.3333, 0.3333],
    description: 'Test 3 different CTAs titles in the welcome section',
    hypothesis: 'We want to find out which CTA title is more effective in converting users to sign up',
  },
];


export const lastFallbackVersion = 1; // Another Fallback, will be used if no active test is found